module.exports = __webpack_public_path__ + "static/media/c-users.b561f200.png";